exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table thead tr{color:#007bff}.error-icon{color:#e34a4a}.success-icon{display:inline-block;color:#4ae387}.table-sm td,.table-sm th{padding:.7rem}.color-icon-label-table td:first-child{width:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09014da6","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tables/Tables.vue
// module id = 548
// module chunks = 27